import React, { useState, useMemo } from 'react';
import { toQuery, fromQuery } from '../../../utils/uri';
import {
  PageHeader,
  PageHeading,
  PageContent,
  makeLinkWrapper,
  StyledLink as PageLink,
} from '../../../components/Page';
import { styled } from 'styletron-react';
import { GraphPagination as Pagination } from '../../../components/Pagination';
import SearchField from '../../../components/SearchField';
import List, { makeListItem } from '../../../components/List';
import GraphQLProvider from '../../../components/GraphQLProvider';
import { useQuery } from '@apollo/client';
import { gql } from '@apollo/client';
import debounce from 'lodash.debounce';
import { connect } from 'react-redux';

const LinkListItem = makeListItem(PageLink);
const LinkWrapper = makeLinkWrapper(LinkListItem);

const Search = styled('div', {
  marginLeft: 'auto',
  flexBasis: '400px',
});

const Recipient = styled('div', {
  display: 'flex',
});
const Name = styled('span', {
  flexBasis: '180px',
  marginRight: '1rem',
});

const USERS_QUERY = gql`
  query ServiceUsersListing($contractId: Int!, $after: String, $before: String, $first: Int, $query: String) {
    contract(id: $contractId) {
      id
      serviceUsers(after: $after, before: $before, first: $first, query: $query) {
        edges {
          node {
            id
            firstName
            lastName
            email
          }
        }
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
      }
    }
  }
`;

const SearchUsers = ({ match, location, history, contractId }) => {
  const urlParams = fromQuery(location.search);
  const [queryInput, setQueryInput] = useState(urlParams.query || '');
  const debounceQuery = useMemo(
    () =>
      debounce((query, history, match, first) => {
        history?.replace(
          `${match.path}?${toQuery({
            query,
            ...(first && {
              first,
            }),
          })}`
        );
      }, 300),
    []
  );

  const variables = {
    contractId: parseInt(contractId),
    ...urlParams,
    first: urlParams.first ? parseInt(urlParams.first) : undefined,
  };

  const { data, loading, error } = useQuery(USERS_QUERY, {
    variables,
    fetchPolicy: 'network-only',
  });

  const handleSearchChange = (e) => {
    setQueryInput(e.target.value);
    if (debounceQuery) {
      debounceQuery(e.target.value, history, match, urlParams.first);
    }
  };

  return (
    <div>
      <GraphQLProvider>
        <div>
          {error && new Error(error.message)}
          <PageHeader>
            <PageHeading>Recipients</PageHeading>
            <Search>
              <SearchField
                placeholder={'Search recipient'}
                value={queryInput}
                onChange={handleSearchChange}
                loading={loading}
              />
            </Search>
          </PageHeader>
          <PageContent>
            <List>
              {!loading &&
                data.contract.serviceUsers.edges
                  .map((e) => e.node)
                  .map((su) => (
                    <LinkWrapper key={su.id} to={`${match.path}/edit/${su.id}`}>
                      <Recipient>
                        <Name>
                          {su.firstName} {su.lastName}
                        </Name>
                        <span>{su.email}</span>
                      </Recipient>
                    </LinkWrapper>
                  ))}
            </List>
            {!loading && (
              <Pagination
                match={match}
                location={location}
                history={history}
                pageInfo={data.contract.serviceUsers.pageInfo}
              />
            )}
          </PageContent>
        </div>
      </GraphQLProvider>
    </div>
  );
};

export default connect((state) => ({
  contractId: state.contracts.selected.id,
}))(SearchUsers);
